import axios from 'axios';
import React from 'react';
import { IntlProvider } from 'react-intl';

const PageDataContext = React.createContext();

export function PageDataProvider({ children }) {
  const clientLang = window.navigator.language.split('-')[0];
  const pageData = useProvideData();
  const messages = pageData.messages
    ? pageData.messages.reduce((values, currentValue) => {
        values[currentValue.key] = currentValue[clientLang] || currentValue.en;
        return values;
      }, {})
    : [];
  return (
    <PageDataContext.Provider value={pageData}>
      <IntlProvider locale="en" messages={messages}>
        {children}
      </IntlProvider>
    </PageDataContext.Provider>
  );
}

function useProvideData() {
  const searchParams = new URLSearchParams(window.location.search);
  const [pageData, setPageData] = React.useState(
    searchParams.has('async') ? {} : window.PAGE_DATA,
  );
  React.useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const fetchPageData = async () => {
      const { default: AirtableClient } = await import('airtable-client');
      const domain = searchParams.get('domain') || 'naming.ai';
      const tld = domain.split('.').pop();
      const api = new AirtableClient({
        key: process.env.REACT_APP_AIRTABLE_KEY,
        base: process.env.REACT_APP_AIRTABLE_BASE,
      });
      const result = await axios.all([
        api.getConfig({
          filterByFormula: `OR({Name} = '${searchParams.get(
            'domain',
          )}', {Name} = '${tld}', {Name} = 'Default')`,
        }),
        api.getMessages(),
        api.getNews(),
      ]);
      setPageData({
        config: {
          ...result[0]['Default'],
          ...result[0][tld],
          ...result[0][domain],
        },
        domain,
        messages: result[1],
        news: result[2].filter(item => item.tld === tld),
        tld,
      });
    };
    // If no page data was rendered to the window.PAGE_DATA by the server,
    // fallback to an async fetch
    if (!window.PAGE_DATA || searchParams.has('async')) {
      fetchPageData();
    }
  }, []);
  return pageData || {};
}

export default () => {
  return React.useContext(PageDataContext);
};
